
import { useLogin } from '@platyplus/vue-hasura-backend-plus'
import { defineComponent, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'Login',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const email = ref('')
    const password = ref('')
    const { login: hbpLogin, error } = useLogin(email, password)
    const login = async () => {
      await hbpLogin()
      if (!error.value) router.replace(route.redirectedFrom || { name: 'home' })
    }
    return {
      email,
      password,
      login,
      error
    }
  }
})
